import Shippings from './ShippingsContainer';

export default Shippings

